import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    FeedHeaderWithLogo,
    isProfileHeader,
} from "web/react/components/feed-header/feed-header-with-logo";
import { useInitialReduxState } from "web/react/hooks/use-inital-redux-state/use-initial-redux-state";
import { setDesignerProfile, triggerBanner } from "web/redux/ducks/follow-designer-banner";
import { ReduxStoreState } from "web/redux/store";
import { ProfileHeaderSerializer, ShopHeaderSerializer } from "web/types/serializers";

export interface FeedHeaderProps {
    title: string | JSX.Element;
    subtitle?: string | JSX.Element;
    actions?: JSX.Element;
    profile?: ProfileHeaderSerializer | ShopHeaderSerializer;
    shopHeader?: boolean;
}

function getInView(bounding: DOMRect): boolean {
    return (
        bounding.top >= -bounding.height &&
        bounding.left >= -bounding.width &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

export function FeedHeader({
    profile,
    subtitle,
    actions,
    ...props
}: FeedHeaderProps): JSX.Element | null {
    const followCTARef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();
    const state = useSelector((state: ReduxStoreState) => state.feedFiltersReducer.title);

    useInitialReduxState([[setDesignerProfile, profile]]);

    useEffect(() => {
        function onScroll(): void {
            if (followCTARef.current) {
                let bounding = followCTARef.current.getBoundingClientRect();
                dispatch(triggerBanner(!getInView(bounding)));
            }
        }
        window.addEventListener("scroll", onScroll);
        return (): void => {
            window.removeEventListener("scroll", onScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (followCTARef.current) {
            let bounding = followCTARef.current.getBoundingClientRect();
            dispatch(triggerBanner(!getInView(bounding)));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [followCTARef.current]);

    let title;

    if (state) {
        title = state;
    } else if (props.title) {
        title = props.title;
    } else if (isProfileHeader(profile) && profile?.name) {
        title = profile.name;
    }

    if (!title) {
        return null;
    }

    return (
        <FeedHeaderWithLogo
            title={title}
            subtitle={subtitle}
            profile={profile}
            followCTARef={followCTARef}
            actions={actions}
        />
    );
}
